import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";


const Languages = ['en', 'ko', 'chi']


i18n.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
        lng:localStorage.getItem('i18nextLng') || 'en',
		supportedLngs:['en','chi'],
		fallbackLng:localStorage.getItem('i18nextLng') || 'en',
		// disabled in production
		// debug: true,
		// detection : {
		// 	order : ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
		// 	caches:['cookie'],
		// },
		// can have multiple namespaces, in case you want to divide a huge
		// translation into smaller pieces and load them on demand
		whitelist : Languages,
		interpolation: {
			espaceValue: false,
		},
		react: {
			wait: true,
			useSuspense : false
		},
	});

export default i18n;
